import { useHeaderMeasure } from '@makemydeal/dr-dash-components';
import type { FC, HTMLAttributes } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { InterstateStyledBodyContainer } from './routes.interstate.style';

export const BodyContainer: FC<HTMLAttributes<HTMLDivElement>> = ({ children }) => {
    const location = useLocation();
    const { height } = useHeaderMeasure();
    useEffect(() => {
        // NOTE: upon navigating to a new location; scroll to the top. Moved here from `Card`.
        window.scroll({
            top: 0,
            left: 0
        });
    }, [location]);

    const theme = useInterstateTheme();

    useEffect(() => {
        document.body.style.backgroundColor = theme.tokens.BaseColorGray50;

        return () => {
            document.body.style.backgroundColor = '';
        };
    }, []);

    return (
        <InterstateStyledBodyContainer $height={height} data-testid="body-container" className="body-container">
            {children}
        </InterstateStyledBodyContainer>
    );
};
